/**
 * Class permettant de facilement définir des méthodes de comparaison.
 * Il suffit de définir `_compareTo` pour que toutes les méthodes soient disponibles.
 */
export abstract class Comparable<T> {
  protected abstract _compareTo(to: Comparable<T>): number

  public gte(to: Comparable<T>): boolean {
    return this._compareTo(to) !== -1;
  }

  public gt(to: Comparable<T>): boolean {
    return this._compareTo(to) === 1;
  }

  public lte(to: Comparable<T>): boolean {
    return this._compareTo(to) !== 1;
  }

  public lt(to: Comparable<T>): boolean {
    return this._compareTo(to) === -1;
  }

  public eq(to: Comparable<T>): boolean {
    return this._compareTo(to) === 0;
  }

  public static max<T extends Comparable<T>>(...comparable: T[]): T {
    return comparable.reduce((max, e) => e.gt(max) ? e : max, comparable[0]);
  }

  public static min<T extends Comparable<T>>(...comparable: T[]): T {
    return comparable.reduce((max, e) => e.lt(max) ? e : max, comparable[0]);
  }
}
